import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider,  } from 'react-intl'
import 'bootstrap/dist/css/bootstrap.css'

import './index.css';
import App from './App';
import { SupportedLanguage, localeContext } from './localeContext';

import en from './lang/en.json'
import it from './lang/it.json'
import fr from './lang/fr.json'
import de from './lang/de.json'


const locales = { en, it, fr, de }

const getLanguageFromNavigator: () => SupportedLanguage  = () => navigator.language.split('-')[0] as SupportedLanguage
const getLanguageFromHash: () => SupportedLanguage = () => window.location.hash.replace('#', '') as SupportedLanguage

const DEFAULT_LANGUAGE = getLanguageFromHash() || getLanguageFromNavigator() || 'en'

const LocalizedWrapper: React.FC = () => {
  const [locale, setLocale] = useState<SupportedLanguage>(DEFAULT_LANGUAGE)
  const [messages, setMessages] = useState(locales[locale])

  useEffect(() => {
    setMessages(locales[locale])
  }, [locale, setMessages])

  const onHashChange = useCallback((_event: HashChangeEvent) => {
    const rawLocale = window.location.hash.replace('#', '')
    if (['it', 'de', 'fr'].includes(rawLocale)) {
      setLocale(rawLocale as any)
    } else {
      setLocale('en')
    }
  }, [])

  useEffect(() => {
    window.addEventListener('hashchange', onHashChange, false)

    return () => window.removeEventListener('hashchange', onHashChange)
  }, [onHashChange])

  return (
    <IntlProvider
      locale={locale}
      messages={messages as any}
    >
      <localeContext.Provider value={locale}>
        <App />
      </localeContext.Provider>
    </IntlProvider>
  )
}

// TODO: move to app so locale can be dynamically changed
const bootstrap = async () => {
  ReactDOM.render(
    <React.StrictMode>
      <LocalizedWrapper />
    </React.StrictMode>,
    document.getElementById('root')
  )
}

bootstrap()
